import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';

import './BaseField.scss';

export interface LzPBase {
  children?: React.ReactNode;
  fluid?: boolean;
  required?: boolean;
  labelShrink?: boolean;
  icon?: React.ReactNode;
  label?: string;
  name?: string;
  id?: string;
  hintText?: string;
  className?: string;
  style?: React.CSSProperties;
  size?: 'tiny' | 'small' | 'medium';
  variant?: 'outlined' | 'filled' | 'standard';
  disabled?: boolean;
  compact?: boolean;
}

const LzXBaseField = (props: LzPBase) => {
  const theName = props.name || '';
  const theId = props.id || 'id_' + theName;

  const styles = props.style || {
    display: props.fluid ? 'block' : 'inline-block',
  };

  return (
    <FormControl
      id={theId}
      style={styles}
      size={'tiny' === props.size ? 'small' : props.size || 'small'}
      variant={props.variant || 'standard'}
      className={
        'lz-base-field ' +
        (props.compact ? 'lz-compact ' : '') +
        (props.className || '')
      }
    >
      {props.label && (
        <InputLabel
          className='lz-label'
          shrink={props.labelShrink}
          variant={props.variant || 'standard'}
        >
          {props.icon && <React.Fragment>{props.icon} </React.Fragment>}
          {props.label}
          {props.required && <b> *</b>}
        </InputLabel>
      )}

      {props.children}

      {props.hintText !== '' && (
        <FormHelperText>{props.hintText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default LzXBaseField;
